import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const Tab5ExamensPhysiques = ({ form, onChange, activeSub, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));

  return (
    <div className="om-fields">

      {/* ── Général ── */}
      {activeSub === "general" && (
        <>
          <div className="om-row">
            <div className="om-field-group om-field-group--small">
              <label>Poids (kg) <ConfidenceLabel confidence={gc("poids")} /></label>
              <input type="number" step="0.1" placeholder="Ex : 47" value={form.poids ?? ""}
                onChange={(e) => onChange("poids", e.target.value)}
                style={{ borderColor: gc("poids").color || undefined }} />
            </div>
            <div className="om-field-group om-field-group--small">
              <label>Taille (m) <ConfidenceLabel confidence={gc("taille")} /></label>
              <input type="number" step="0.01" placeholder="Ex : 1.64" value={form.taille ?? ""}
                onChange={(e) => onChange("taille", e.target.value)}
                style={{ borderColor: gc("taille").color || undefined }} />
            </div>
            <div className="om-field-group om-field-group--small">
              <label>SC (m²) <ConfidenceLabel confidence={gc("sc")} /></label>
              <input type="number" step="0.01" placeholder="Ex : 1.42" value={form.sc ?? ""}
                onChange={(e) => onChange("sc", e.target.value)}
                style={{ borderColor: gc("sc").color || undefined }} />
            </div>
            <div className="om-field-group om-field-group--small">
              <label>PB (cm) <ConfidenceLabel confidence={gc("pb")} /></label>
              <input type="number" step="0.1" placeholder="PB" value={form.pb ?? ""}
                onChange={(e) => onChange("pb", e.target.value)}
                style={{ borderColor: gc("pb").color || undefined }} />
            </div>
          </div>
          <div className="om-row">
            <div className="om-field-group om-field-group--small">
              <label>Z-score <ConfidenceLabel confidence={gc("zscore")} /></label>
              <input type="text" placeholder="Z-score" value={form.zscore ?? ""}
                onChange={(e) => onChange("zscore", e.target.value)}
                style={{ borderColor: gc("zscore").color || undefined }} />
            </div>
            <div className="om-field-group om-field-group--small">
              <label>PC <ConfidenceLabel confidence={gc("pc")} /></label>
              <input type="text" placeholder="PC" value={form.pc ?? ""}
                onChange={(e) => onChange("pc", e.target.value)}
                style={{ borderColor: gc("pc").color || undefined }} />
            </div>
          </div>
          <div className="om-row">
            <div className="om-field-group om-field-group--small">
              <label>FC (/min) <ConfidenceLabel confidence={gc("fc")} /></label>
              <input type="number" placeholder="Ex : 122" value={form.fc ?? ""}
                onChange={(e) => onChange("fc", e.target.value)}
                style={{ borderColor: gc("fc").color || undefined }} />
            </div>
            <div className="om-field-group om-field-group--small">
              <label>FR (/min) <ConfidenceLabel confidence={gc("fr")} /></label>
              <input type="number" placeholder="Ex : 25" value={form.fr ?? ""}
                onChange={(e) => onChange("fr", e.target.value)}
                style={{ borderColor: gc("fr").color || undefined }} />
            </div>
            <div className="om-field-group om-field-group--small">
              <label>TA (mmHg) <ConfidenceLabel confidence={gc("ta")} /></label>
              <input type="text" placeholder="Ex : 120/65" value={form.ta ?? ""}
                onChange={(e) => onChange("ta", e.target.value)}
                style={{ borderColor: gc("ta").color || undefined }} />
            </div>
            <div className="om-field-group om-field-group--small">
              <label>T° (°C) <ConfidenceLabel confidence={gc("temperature")} /></label>
              <input type="number" step="0.1" placeholder="Ex : 38.3" value={form.temperature ?? ""}
                onChange={(e) => onChange("temperature", e.target.value)}
                style={{ borderColor: gc("temperature").color || undefined }} />
            </div>
          </div>
          <div className="om-row">
            <div className="om-field-group om-field-group--small">
              <label>Score de Lansky (%) <ConfidenceLabel confidence={gc("score_lansky")} /></label>
              <input type="number" min="0" max="100" placeholder="%" value={form.score_lansky ?? ""}
                onChange={(e) => onChange("score_lansky", e.target.value)}
                style={{ borderColor: gc("score_lansky").color || undefined }} />
            </div>
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Évaluation de la douleur <ConfidenceLabel confidence={gc("douleur")} /></label>
              <select value={form.douleur ?? ""} onChange={(e) => onChange("douleur", e.target.value)}
                style={{ borderColor: gc("douleur").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            {form.douleur === "oui" && (
              <>
                <div className="om-field-group om-field-group--small">
                  <label>Échelle <ConfidenceLabel confidence={gc("douleur_echelle")} /></label>
                  <input type="text" placeholder="Ex : CVP..." value={form.douleur_echelle ?? ""}
                    onChange={(e) => onChange("douleur_echelle", e.target.value)}
                    style={{ borderColor: gc("douleur_echelle").color || undefined }} />
                </div>
                <div className="om-field-group om-field-group--small">
                  <label>Score <ConfidenceLabel confidence={gc("douleur_score")} /></label>
                  <input type="number" min="0" placeholder="Score" value={form.douleur_score ?? ""}
                    onChange={(e) => onChange("douleur_score", e.target.value)}
                    style={{ borderColor: gc("douleur_score").color || undefined }} />
                </div>
              </>
            )}
          </div>
          <div className="om-field-group">
            <label>Coloration des muqueuses et téguments <ConfidenceLabel confidence={gc("coloration_muqueuses")} /></label>
            <select value={form.coloration_muqueuses ?? ""} onChange={(e) => onChange("coloration_muqueuses", e.target.value)}
              style={{ borderColor: gc("coloration_muqueuses").color || undefined }}>
              <option value="">—</option>
              <option value="normale">Normale</option>
              <option value="pale">Pâle</option>
              <option value="icterique">Ictérique</option>
            </select>
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Œdèmes <ConfidenceLabel confidence={gc("oedemes")} /></label>
              <select value={form.oedemes ?? ""} onChange={(e) => onChange("oedemes", e.target.value)}
                style={{ borderColor: gc("oedemes").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            {form.oedemes === "oui" && (
              <div className="om-field-group">
                <label>Préciser le grade <ConfidenceLabel confidence={gc("oedemes_grade")} /></label>
                <input type="text" placeholder="Grade des œdèmes" value={form.oedemes_grade ?? ""}
                  onChange={(e) => onChange("oedemes_grade", e.target.value)}
                  style={{ borderColor: gc("oedemes_grade").color || undefined }} />
              </div>
            )}
          </div>
        </>
      )}

      {/* ── Ophtalmologie ── */}
      {activeSub === "ophtalmologie" && (
        <>
          <div className="om-field-group">
            <label>Anomalies ophtalmologiques <ConfidenceLabel confidence={gc("ophtalmo_anomalies")} /></label>
            <select value={form.ophtalmo_anomalies ?? ""} onChange={(e) => onChange("ophtalmo_anomalies", e.target.value)}
              style={{ borderColor: gc("ophtalmo_anomalies").color || undefined }}>
              <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
            </select>
          </div>
          {form.ophtalmo_anomalies === "oui" && (
            <>
              <div className="om-section-label">Signes oculaires</div>
              <div className="om-checkboxes">
                {["Tuméfaction palpébrale","Exophtalmie","Leucocorie","Buphthalmie","Strabisme","Œil rouge douloureux"].map((item) => {
                  const key = `ophtalmo_${item.toLowerCase().replace(/\s+/g,"_").replace(/[éèê]/g,"e").replace(/[àâ]/g,"a").replace(/[œ]/g,"oe")}`;
                  return (
                    <label key={item} className="om-checkbox-label">
                      <input type="checkbox" checked={form[key] === true}
                        onChange={(e) => onChange(key, e.target.checked)} />
                      {item}
                    </label>
                  );
                })}
              </div>
              <div className="om-field-group">
                <label>Grade (si Exophtalmie) <ConfidenceLabel confidence={gc("ophtalmo_exophtalmie_grade")} /></label>
                <input type="text" placeholder="Grade..." value={form.ophtalmo_exophtalmie_grade ?? ""}
                  onChange={(e) => onChange("ophtalmo_exophtalmie_grade", e.target.value)}
                  style={{ borderColor: gc("ophtalmo_exophtalmie_grade").color || undefined }} />
              </div>
              <div className="om-field-group">
                <label>Autres signes oculaires <ConfidenceLabel confidence={gc("ophtalmo_autres")} /></label>
                <textarea rows={3} placeholder="Préciser..." value={form.ophtalmo_autres ?? ""}
                  onChange={(e) => onChange("ophtalmo_autres", e.target.value)}
                  style={{ borderColor: gc("ophtalmo_autres").color || undefined }} />
              </div>
            </>
          )}
        </>
      )}

      {/* ── Maxillo-facial ── */}
      {activeSub === "maxilo_facial" && (
        <>
          <div className="om-row">
            <div className="om-field-group">
              <label>Tuméfaction maxillaire <ConfidenceLabel confidence={gc("tumefaction_maxillaire")} /></label>
              <select value={form.tumefaction_maxillaire ?? ""} onChange={(e) => onChange("tumefaction_maxillaire", e.target.value)}
                style={{ borderColor: gc("tumefaction_maxillaire").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            {form.tumefaction_maxillaire === "oui" && (
              <div className="om-field-group">
                <label>Côté <ConfidenceLabel confidence={gc("tumefaction_maxillaire_cote")} /></label>
                <select value={form.tumefaction_maxillaire_cote ?? ""} onChange={(e) => onChange("tumefaction_maxillaire_cote", e.target.value)}
                  style={{ borderColor: gc("tumefaction_maxillaire_cote").color || undefined }}>
                  <option value="">—</option><option value="gauche">Gauche</option><option value="droite">Droite</option>
                </select>
              </div>
            )}
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Tuméfaction mandibulaire <ConfidenceLabel confidence={gc("tumefaction_mandibulaire")} /></label>
              <select value={form.tumefaction_mandibulaire ?? ""} onChange={(e) => onChange("tumefaction_mandibulaire", e.target.value)}
                style={{ borderColor: gc("tumefaction_mandibulaire").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            {form.tumefaction_mandibulaire === "oui" && (
              <div className="om-field-group">
                <label>Côté <ConfidenceLabel confidence={gc("tumefaction_mandibulaire_cote")} /></label>
                <select value={form.tumefaction_mandibulaire_cote ?? ""} onChange={(e) => onChange("tumefaction_mandibulaire_cote", e.target.value)}
                  style={{ borderColor: gc("tumefaction_mandibulaire_cote").color || undefined }}>
                  <option value="">—</option><option value="gauche">Gauche</option><option value="droite">Droite</option>
                </select>
              </div>
            )}
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Bourgeon endobuccal <ConfidenceLabel confidence={gc("bourgeon_endobuccal")} /></label>
              <select value={form.bourgeon_endobuccal ?? ""} onChange={(e) => onChange("bourgeon_endobuccal", e.target.value)}
                style={{ borderColor: gc("bourgeon_endobuccal").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
          </div>
          {form.bourgeon_endobuccal === "oui" && (
            <div className="om-field-group">
              <label>Caractères du bourgeon <ConfidenceLabel confidence={gc("bourgeon_caracteres")} /></label>
              <textarea rows={2} placeholder="Préciser..." value={form.bourgeon_caracteres ?? ""}
                onChange={(e) => onChange("bourgeon_caracteres", e.target.value)}
                style={{ borderColor: gc("bourgeon_caracteres").color || undefined }} />
            </div>
          )}
          <div className="om-row">
            <div className="om-field-group">
              <label>Désorganisation articulé dentaire <ConfidenceLabel confidence={gc("desorganisation_dentaire")} /></label>
              <select value={form.desorganisation_dentaire ?? ""} onChange={(e) => onChange("desorganisation_dentaire", e.target.value)}
                style={{ borderColor: gc("desorganisation_dentaire").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            <div className="om-field-group">
              <label>Mobilité des dents <ConfidenceLabel confidence={gc("mobilite_dents")} /></label>
              <select value={form.mobilite_dents ?? ""} onChange={(e) => onChange("mobilite_dents", e.target.value)}
                style={{ borderColor: gc("mobilite_dents").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            <div className="om-field-group">
              <label>Chute dentaire <ConfidenceLabel confidence={gc("chute_dentaire")} /></label>
              <select value={form.chute_dentaire ?? ""} onChange={(e) => onChange("chute_dentaire", e.target.value)}
                style={{ borderColor: gc("chute_dentaire").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
          </div>
          {(form.mobilite_dents === "oui" || form.chute_dentaire === "oui") && (
            <div className="om-field-group">
              <label>Numéros des dents concernées <ConfidenceLabel confidence={gc("dents_concernees")} /></label>
              <input type="text" placeholder="Ex : 11, 21, 36..." value={form.dents_concernees ?? ""}
                onChange={(e) => onChange("dents_concernees", e.target.value)}
                style={{ borderColor: gc("dents_concernees").color || undefined }} />
            </div>
          )}
          <div className="om-field-group">
            <label>État dentaire global <ConfidenceLabel confidence={gc("etat_dentaire")} /></label>
            <textarea rows={2} placeholder="Description..." value={form.etat_dentaire ?? ""}
              onChange={(e) => onChange("etat_dentaire", e.target.value)}
              style={{ borderColor: gc("etat_dentaire").color || undefined }} />
          </div>
          <div className="om-field-group">
            <label>Caractères de la peau <ConfidenceLabel confidence={gc("peau_caracteres")} /></label>
            <select value={form.peau_caracteres ?? ""} onChange={(e) => onChange("peau_caracteres", e.target.value)}
              style={{ borderColor: gc("peau_caracteres").color || undefined }}>
              <option value="">—</option>
              <option value="saine">Saine</option>
              <option value="ulceree">Ulcérée</option>
              <option value="luisante">Luisante</option>
              <option value="lacis_veineux">Parcourue d'un lacis veineux</option>
            </select>
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Pertuis laissant sourdre du pus <ConfidenceLabel confidence={gc("pertuis_pus")} /></label>
              <select value={form.pertuis_pus ?? ""} onChange={(e) => onChange("pertuis_pus", e.target.value)}
                style={{ borderColor: gc("pertuis_pus").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
          </div>
          <div className="om-field-group">
            <label>État des amygdales <ConfidenceLabel confidence={gc("etat_amygdales")} /></label>
            <input type="text" placeholder="Description..." value={form.etat_amygdales ?? ""}
              onChange={(e) => onChange("etat_amygdales", e.target.value)}
              style={{ borderColor: gc("etat_amygdales").color || undefined }} />
          </div>
          <div className="om-field-group">
            <label>État des tympans <ConfidenceLabel confidence={gc("etat_tympans")} /></label>
            <input type="text" placeholder="Description..." value={form.etat_tympans ?? ""}
              onChange={(e) => onChange("etat_tympans", e.target.value)}
              style={{ borderColor: gc("etat_tympans").color || undefined }} />
          </div>
          <div className="om-field-group">
            <label>Autre(précisez) <ConfidenceLabel confidence={gc("maxilofacial_autre")} /></label>
            <textarea rows={2} placeholder="Autres signes..." value={form.maxilofacial_autre ?? ""}
              onChange={(e) => onChange("maxilofacial_autre", e.target.value)}
              style={{ borderColor: gc("maxilofacial_autre").color || undefined }} />
          </div>
        </>
      )}

      {/* ── Abdomen & Pelvis ── */}
      {activeSub === "abdomen_pelvis" && (
        <>
          <div className="om-field-group">
            <label>Anomalies abdomen / pelvis <ConfidenceLabel confidence={gc("abdomen_anomalies")} /></label>
            <select value={form.abdomen_anomalies ?? ""} onChange={(e) => onChange("abdomen_anomalies", e.target.value)}
              style={{ borderColor: gc("abdomen_anomalies").color || undefined }}>
              <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
            </select>
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Distension abdominale <ConfidenceLabel confidence={gc("distension_abdominale")} /></label>
              <select value={form.distension_abdominale ?? ""} onChange={(e) => onChange("distension_abdominale", e.target.value)}
                style={{ borderColor: gc("distension_abdominale").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
          </div>
          {form.distension_abdominale === "oui" && (
            <div className="om-row">
              <div className="om-field-group">
                <label>Périmètre ombilical (cm) <ConfidenceLabel confidence={gc("perimetre_ombilical")} /></label>
                <input type="number" step="0.1" placeholder="Ex : 82.5" value={form.perimetre_ombilical ?? ""}
                  onChange={(e) => onChange("perimetre_ombilical", e.target.value)}
                  style={{ borderColor: gc("perimetre_ombilical").color || undefined }} />
              </div>
              <div className="om-field-group">
                <label>Périmètre abdominal max (cm) <ConfidenceLabel confidence={gc("perimetre_abdominal_max")} /></label>
                <input type="number" step="0.1" placeholder="Ex : 81.5" value={form.perimetre_abdominal_max ?? ""}
                  onChange={(e) => onChange("perimetre_abdominal_max", e.target.value)}
                  style={{ borderColor: gc("perimetre_abdominal_max").color || undefined }} />
              </div>
            </div>
          )}
          <div className="om-row">
            <div className="om-field-group">
              <label>Circulations veineuses collatérales <ConfidenceLabel confidence={gc("circulations_veineuses")} /></label>
              <select value={form.circulations_veineuses ?? ""} onChange={(e) => onChange("circulations_veineuses", e.target.value)}
                style={{ borderColor: gc("circulations_veineuses").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            <div className="om-field-group">
              <label>Déplissement de l'ombilic <ConfidenceLabel confidence={gc("deplissement_ombilic")} /></label>
              <select value={form.deplissement_ombilic ?? ""} onChange={(e) => onChange("deplissement_ombilic", e.target.value)}
                style={{ borderColor: gc("deplissement_ombilic").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Ascite <ConfidenceLabel confidence={gc("ascite")} /></label>
              <select value={form.ascite ?? ""} onChange={(e) => onChange("ascite", e.target.value)}
                style={{ borderColor: gc("ascite").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            {form.ascite === "oui" && (
              <div className="om-field-group">
                <label>Abondance <ConfidenceLabel confidence={gc("ascite_abondance")} /></label>
                <select value={form.ascite_abondance ?? ""} onChange={(e) => onChange("ascite_abondance", e.target.value)}
                  style={{ borderColor: gc("ascite_abondance").color || undefined }}>
                  <option value="">—</option><option value="moyenne">Moyenne</option><option value="grande">Grande</option>
                </select>
              </div>
            )}
          </div>
          <div className="om-row">
            {[["foie","Foie"],["rate","Rate"],["reins","Reins"]].map(([key, label]) => (
              <div key={key} className="om-field-group">
                <label>{label} <ConfidenceLabel confidence={gc(key)} /></label>
                <select value={form[key] ?? ""} onChange={(e) => onChange(key, e.target.value)}
                  style={{ borderColor: gc(key).color || undefined }}>
                  <option value="">—</option>
                  <option value="normal">Normal{key==="rate"?"e":""}</option>
                  <option value="anormal">Anormal{key==="rate"?"e":key==="reins"?"aux":""}</option>
                </select>
              </div>
            ))}
          </div>
          {form.foie === "anormal" && (
            <div className="om-field-group">
              <label>Caractères et dimensions du foie <ConfidenceLabel confidence={gc("foie_details")} /></label>
              <textarea rows={2} placeholder="Préciser..." value={form.foie_details ?? ""}
                onChange={(e) => onChange("foie_details", e.target.value)}
                style={{ borderColor: gc("foie_details").color || undefined }} />
            </div>
          )}
          {form.rate === "anormale" && (
            <div className="om-field-group">
              <label>Caractères et dimensions de la rate <ConfidenceLabel confidence={gc("rate_details")} /></label>
              <textarea rows={2} placeholder="Préciser..." value={form.rate_details ?? ""}
                onChange={(e) => onChange("rate_details", e.target.value)}
                style={{ borderColor: gc("rate_details").color || undefined }} />
            </div>
          )}
          {form.reins === "anormaux" && (
            <div className="om-field-group">
              <label>Caractères, latéralité et dimensions des reins <ConfidenceLabel confidence={gc("reins_details")} /></label>
              <textarea rows={2} placeholder="Préciser..." value={form.reins_details ?? ""}
                onChange={(e) => onChange("reins_details", e.target.value)}
                style={{ borderColor: gc("reins_details").color || undefined }} />
            </div>
          )}
          <div className="om-row">
            <div className="om-field-group">
              <label>Autre masse abdominale <ConfidenceLabel confidence={gc("autre_masse_abdominale")} /></label>
              <select value={form.autre_masse_abdominale ?? ""} onChange={(e) => onChange("autre_masse_abdominale", e.target.value)}
                style={{ borderColor: gc("autre_masse_abdominale").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
          </div>
          {form.autre_masse_abdominale === "oui" && (
            <div className="om-field-group">
              <label>Siège, caractères et dimensions <ConfidenceLabel confidence={gc("autre_masse_details")} /></label>
              <textarea rows={2} placeholder="Préciser..." value={form.autre_masse_details ?? ""}
                onChange={(e) => onChange("autre_masse_details", e.target.value)}
                style={{ borderColor: gc("autre_masse_details").color || undefined }} />
            </div>
          )}
          <div className="om-row">
            <div className="om-field-group">
              <label>Masse pelvienne <ConfidenceLabel confidence={gc("masse_pelvienne")} /></label>
              <select value={form.masse_pelvienne ?? ""} onChange={(e) => onChange("masse_pelvienne", e.target.value)}
                style={{ borderColor: gc("masse_pelvienne").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
          </div>
          {form.masse_pelvienne === "oui" && (
            <div className="om-field-group">
              <label>Siège, caractères et dimensions (masse pelvienne) <ConfidenceLabel confidence={gc("masse_pelvienne_details")} /></label>
              <textarea rows={2} placeholder="Préciser..." value={form.masse_pelvienne_details ?? ""}
                onChange={(e) => onChange("masse_pelvienne_details", e.target.value)}
                style={{ borderColor: gc("masse_pelvienne_details").color || undefined }} />
            </div>
          )}
          <div className="om-field-group">
            <label>Toucher(s) pelvien(s) <ConfidenceLabel confidence={gc("toucher_pelvien")} /></label>
            <input type="text" placeholder="Description..." value={form.toucher_pelvien ?? ""}
              onChange={(e) => onChange("toucher_pelvien", e.target.value)}
              style={{ borderColor: gc("toucher_pelvien").color || undefined }} />
          </div>
          <div className="om-field-group">
            <label>Organes génitaux <ConfidenceLabel confidence={gc("organes_genitaux")} /></label>
            <input type="text" placeholder="Description..." value={form.organes_genitaux ?? ""}
              onChange={(e) => onChange("organes_genitaux", e.target.value)}
              style={{ borderColor: gc("organes_genitaux").color || undefined }} />
          </div>
        </>
      )}

      {/* ── Neurologique ── */}
      {activeSub === "neurologique" && (
        <>
          <div className="om-field-group">
            <label>Anomalies neurologiques <ConfidenceLabel confidence={gc("neuro_anomalies")} /></label>
            <select value={form.neuro_anomalies ?? ""} onChange={(e) => onChange("neuro_anomalies", e.target.value)}
              style={{ borderColor: gc("neuro_anomalies").color || undefined }}>
              <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
            </select>
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Conscience <ConfidenceLabel confidence={gc("conscience")} /></label>
              <select value={form.conscience ?? ""} onChange={(e) => onChange("conscience", e.target.value)}
                style={{ borderColor: gc("conscience").color || undefined }}>
                <option value="">—</option><option value="normale">Normale</option><option value="coma">Coma</option>
              </select>
            </div>
            {form.conscience === "coma" && (
              <div className="om-field-group">
                <label>Score de coma <ConfidenceLabel confidence={gc("score_coma")} /></label>
                <input type="text" placeholder="Score GCS..." value={form.score_coma ?? ""}
                  onChange={(e) => onChange("score_coma", e.target.value)}
                  style={{ borderColor: gc("score_coma").color || undefined }} />
              </div>
            )}
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Atteinte des paires crâniennes <ConfidenceLabel confidence={gc("paires_craniennes")} /></label>
              <select value={form.paires_craniennes ?? ""} onChange={(e) => onChange("paires_craniennes", e.target.value)}
                style={{ borderColor: gc("paires_craniennes").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            {form.paires_craniennes === "oui" && (
              <div className="om-field-group">
                <label>Préciser <ConfidenceLabel confidence={gc("paires_craniennes_details")} /></label>
                <input type="text" placeholder="Préciser..." value={form.paires_craniennes_details ?? ""}
                  onChange={(e) => onChange("paires_craniennes_details", e.target.value)}
                  style={{ borderColor: gc("paires_craniennes_details").color || undefined }} />
              </div>
            )}
          </div>
          <div className="om-field-group">
            <label>Motricité <ConfidenceLabel confidence={gc("motricite")} /></label>
            <select value={form.motricite ?? ""} onChange={(e) => onChange("motricite", e.target.value)}
              style={{ borderColor: gc("motricite").color || undefined }}>
              <option value="">—</option>
              <option value="normal">Normal</option>
              <option value="paraparesie">Paraparésie</option>
              <option value="paraplegie">Paraplégie</option>
              <option value="hemiplegie">Hémiplégie</option>
            </select>
          </div>
          <div className="om-field-group">
            <label>Sensibilité <ConfidenceLabel confidence={gc("sensibilite")} /></label>
            <select value={form.sensibilite ?? ""} onChange={(e) => onChange("sensibilite", e.target.value)}
              style={{ borderColor: gc("sensibilite").color || undefined }}>
              <option value="">—</option>
              <option value="normale">Normale</option>
              <option value="diminuee">Diminuée</option>
              <option value="abolie">Abolie</option>
            </select>
          </div>
          <div className="om-field-group">
            <label>Réflexes ostéotendineux <ConfidenceLabel confidence={gc("reflexes")} /></label>
            <select value={form.reflexes ?? ""} onChange={(e) => onChange("reflexes", e.target.value)}
              style={{ borderColor: gc("reflexes").color || undefined }}>
              <option value="">—</option>
              <option value="abolis">Abolis</option>
              <option value="vifs">Vifs</option>
              <option value="normaux">Normaux</option>
            </select>
          </div>
          <div className="om-field-group">
            <label>Anomalies sensitives/motrices/réflexes <ConfidenceLabel confidence={gc("anomalies_neuro")} /></label>
            <textarea rows={3} placeholder="Préciser..." value={form.anomalies_neuro ?? ""}
              onChange={(e) => onChange("anomalies_neuro", e.target.value)}
              style={{ borderColor: gc("anomalies_neuro").color || undefined }} />
          </div>
          <div className="om-field-group">
            <label>Troubles sphinctériens <ConfidenceLabel confidence={gc("troubles_sphincteriens")} /></label>
            <select value={form.troubles_sphincteriens ?? ""} onChange={(e) => onChange("troubles_sphincteriens", e.target.value)}
              style={{ borderColor: gc("troubles_sphincteriens").color || undefined }}>
              <option value="">—</option>
              <option value="absents">Absents</option>
              <option value="incontinence">Incontinence rectale et/ou urinaire</option>
            </select>
          </div>
        </>
      )}

      {/* ── Aires ganglionnaires ── */}
      {activeSub === "aires_ganglion" && (
        <>
          <div className="om-field-group">
            <label>Anomalies des aires ganglionnaires <ConfidenceLabel confidence={gc("ganglion_anomalies")} /></label>
            <select value={form.ganglion_anomalies ?? ""} onChange={(e) => onChange("ganglion_anomalies", e.target.value)}
              style={{ borderColor: gc("ganglion_anomalies").color || undefined }}>
              <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
            </select>
          </div>
          <div className="om-section-label">Adénopathies (ADP)</div>
          <div className="om-row">
            {[
              ["adp_pre_tragiennes","ADP pré-tragiennes / cervicales"],
              ["adp_sus_claviculaires","ADP sus-claviculaires"],
              ["adp_axillaires","ADP axillaires"],
              ["adp_inguinales","ADP inguinales"],
              ["adp_autres","ADP autres territoires"],
            ].map(([key, label]) => (
              <div key={key} className="om-field-group">
                <label>{label} <ConfidenceLabel confidence={gc(key)} /></label>
                <select value={form[key] ?? ""} onChange={(e) => onChange(key, e.target.value)}
                  style={{ borderColor: gc(key).color || undefined }}>
                  <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
                </select>
              </div>
            ))}
          </div>
          <div className="om-field-group">
            <label>Si ADP présentes : topographie, taille et schéma <ConfidenceLabel confidence={gc("adp_details")} /></label>
            <textarea rows={4} placeholder="Ex : mobiles, indolores, 5cm à gauche..."
              value={form.adp_details ?? ""}
              onChange={(e) => onChange("adp_details", e.target.value)}
              style={{ borderColor: gc("adp_details").color || undefined }} />
          </div>
        </>
      )}

      {/* ── Locomoteur ── */}
      {activeSub === "locomoteur" && (
        <>
          <div className="om-field-group">
            <label>Anomalies locomotrices <ConfidenceLabel confidence={gc("locomoteur_anomalies")} /></label>
            <select value={form.locomoteur_anomalies ?? ""} onChange={(e) => onChange("locomoteur_anomalies", e.target.value)}
              style={{ borderColor: gc("locomoteur_anomalies").color || undefined }}>
              <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
            </select>
          </div>
          <div className="om-section-label">Signes fonctionnels</div>
          <div className="om-checkboxes">
            {["Douleur(s) ostéoarticulaire(s)","Boiterie","Impotence fonctionnelle","Autre"].map((item) => {
              const key = `locomoteur_sf_${item.toLowerCase().replace(/[^a-z]/g,"_")}`;
              return (
                <label key={item} className="om-checkbox-label">
                  <input type="checkbox" checked={form[key] === true}
                    onChange={(e) => onChange(key, e.target.checked)} />
                  {item}
                </label>
              );
            })}
          </div>
          <div className="om-field-group">
            <label>Si SF présents, préciser <ConfidenceLabel confidence={gc("locomoteur_sf_details")} /></label>
            <textarea rows={2} placeholder="Préciser..." value={form.locomoteur_sf_details ?? ""}
              onChange={(e) => onChange("locomoteur_sf_details", e.target.value)}
              style={{ borderColor: gc("locomoteur_sf_details").color || undefined }} />
          </div>
          <div className="om-section-label">Examen</div>
          <div className="om-checkboxes">
            {["Déformation","Inflammation","Épanchement","Raideur","Anomalie d'origine traumatique","Autre"].map((item) => {
              const key = `locomoteur_exam_${item.toLowerCase().replace(/[^a-z]/g,"_")}`;
              return (
                <label key={item} className="om-checkbox-label">
                  <input type="checkbox" checked={form[key] === true}
                    onChange={(e) => onChange(key, e.target.checked)} />
                  {item}
                </label>
              );
            })}
          </div>
          <div className="om-field-group">
            <label>Si examen anormal, préciser <ConfidenceLabel confidence={gc("locomoteur_exam_details")} /></label>
            <textarea rows={2} placeholder="Préciser..." value={form.locomoteur_exam_details ?? ""}
              onChange={(e) => onChange("locomoteur_exam_details", e.target.value)}
              style={{ borderColor: gc("locomoteur_exam_details").color || undefined }} />
          </div>
        </>
      )}

      {/* ── Cardio-thoracique ── */}
      {activeSub === "cardio_thoracique" && (
        <>
          <div className="om-field-group">
            <label>Anomalies cardio-thoraciques <ConfidenceLabel confidence={gc("cardio_anomalies")} /></label>
            <select value={form.cardio_anomalies ?? ""} onChange={(e) => onChange("cardio_anomalies", e.target.value)}
              style={{ borderColor: gc("cardio_anomalies").color || undefined }}>
              <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
            </select>
          </div>
          <div className="om-section-label">Signes fonctionnels</div>
          <div className="om-checkboxes">
            {["Dyspnée","Douleur thoracique","Toux","Expectoration","Syncopes/Malaises","Autre"].map((item) => {
              const key = `cardio_sf_${item.toLowerCase().replace(/[^a-z]/g,"_")}`;
              return (
                <label key={item} className="om-checkbox-label">
                  <input type="checkbox" checked={form[key] === true}
                    onChange={(e) => onChange(key, e.target.checked)} />
                  {item}
                </label>
              );
            })}
          </div>
          <div className="om-field-group">
            <label>Si SF présents, préciser <ConfidenceLabel confidence={gc("cardio_sf_details")} /></label>
            <textarea rows={2} placeholder="Préciser..." value={form.cardio_sf_details ?? ""}
              onChange={(e) => onChange("cardio_sf_details", e.target.value)}
              style={{ borderColor: gc("cardio_sf_details").color || undefined }} />
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Anomalie du thorax <ConfidenceLabel confidence={gc("anomalie_thorax")} /></label>
              <select value={form.anomalie_thorax ?? ""} onChange={(e) => onChange("anomalie_thorax", e.target.value)}
                style={{ borderColor: gc("anomalie_thorax").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
            <div className="om-field-group">
              <label>Anomalie de la respiration <ConfidenceLabel confidence={gc("anomalie_respiration")} /></label>
              <select value={form.anomalie_respiration ?? ""} onChange={(e) => onChange("anomalie_respiration", e.target.value)}
                style={{ borderColor: gc("anomalie_respiration").color || undefined }}>
                <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
              </select>
            </div>
          </div>
          <div className="om-row">
            <div className="om-field-group">
              <label>Examen cardiovasculaire <ConfidenceLabel confidence={gc("examen_cardiovasculaire")} /></label>
              <select value={form.examen_cardiovasculaire ?? ""} onChange={(e) => onChange("examen_cardiovasculaire", e.target.value)}
                style={{ borderColor: gc("examen_cardiovasculaire").color || undefined }}>
                <option value="">—</option><option value="normal">Normal</option><option value="anormal">Anormal</option>
              </select>
            </div>
          </div>
          {form.examen_cardiovasculaire === "anormal" && (
            <div className="om-field-group">
              <label>Préciser (cardiovasculaire) <ConfidenceLabel confidence={gc("examen_cardiovasculaire_details")} /></label>
              <textarea rows={2} placeholder="Préciser..." value={form.examen_cardiovasculaire_details ?? ""}
                onChange={(e) => onChange("examen_cardiovasculaire_details", e.target.value)}
                style={{ borderColor: gc("examen_cardiovasculaire_details").color || undefined }} />
            </div>
          )}
          <div className="om-row">
            <div className="om-field-group">
              <label>Examen respiratoire <ConfidenceLabel confidence={gc("examen_respiratoire")} /></label>
              <select value={form.examen_respiratoire ?? ""} onChange={(e) => onChange("examen_respiratoire", e.target.value)}
                style={{ borderColor: gc("examen_respiratoire").color || undefined }}>
                <option value="">—</option><option value="normal">Normal</option><option value="anormal">Anormal</option>
              </select>
            </div>
          </div>
          {form.examen_respiratoire === "anormal" && (
            <div className="om-field-group">
              <label>Préciser (respiratoire) <ConfidenceLabel confidence={gc("examen_respiratoire_details")} /></label>
              <textarea rows={2} placeholder="Préciser..." value={form.examen_respiratoire_details ?? ""}
                onChange={(e) => onChange("examen_respiratoire_details", e.target.value)}
                style={{ borderColor: gc("examen_respiratoire_details").color || undefined }} />
            </div>
          )}
        </>
      )}

      {/* ── Autres appareils ── */}
      {activeSub === "autres_appareils" && (
        <>
          <div className="om-field-group">
            <label>Anomalies des autres appareils <ConfidenceLabel confidence={gc("autres_appareils_anomalies")} /></label>
            <select value={form.autres_appareils_anomalies ?? ""} onChange={(e) => onChange("autres_appareils_anomalies", e.target.value)}
              style={{ borderColor: gc("autres_appareils_anomalies").color || undefined }}>
              <option value="">—</option><option value="oui">Oui</option><option value="non">Non</option>
            </select>
          </div>
          {form.autres_appareils_anomalies === "oui" && (
            <div className="om-field-group">
              <label>Préciser <ConfidenceLabel confidence={gc("autres_appareils_details")} /></label>
              <textarea rows={6} placeholder="Décrire les anomalies des autres appareils..."
                value={form.autres_appareils_details ?? ""}
                onChange={(e) => onChange("autres_appareils_details", e.target.value)}
                style={{ borderColor: gc("autres_appareils_details").color || undefined }} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Tab5ExamensPhysiques;